import { render, staticRenderFns } from "./OnboardingDomainTransferModal.vue?vue&type=template&id=6f1fe380&scoped=true"
import script from "./OnboardingDomainTransferModal.vue?vue&type=script&lang=js"
export * from "./OnboardingDomainTransferModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingDomainTransferModal.vue?vue&type=style&index=0&id=6f1fe380&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1fe380",
  null
  
)

export default component.exports